import React, { useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import notify from "../../components/notifier";
import CasinoSlider from "../Slider/CasinoSlider";
import LiveCasinoList from "../Home/LiveCasinoList";
import MiniGameList from "../Home/MiniGameList";
import VirtualGames from "../Home/VirtualGames";
import OwlCarousel from "react-owl-carousel";
import User from "../../services/user";
import Casino from "../../components/Casino";
import { MdOutlineSportsCricket } from "react-icons/md";
import { MdOutlineSportsSoccer } from "react-icons/md";
import { MdOutlineSportsFootball } from "react-icons/md";
import { MdSportsTennis } from "react-icons/md";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet";

import { Table } from "reactstrap";

import MEDIA_URL from "../../contants";
const GamesListing = (props) => {
  const clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
  const CurrentGameType = props.gameType
    ? props.gameType
    : props.match.params.gType;
  const [gTypes, setgTypes] = useState("CRCKT");
  const [darkMode, setDarkMode] = useState(true);
  const [webSlides, setwebSlides] = React.useState([]);
  const [sports, setSports] = React.useState([]);
  const [sportsTNNS, setSportsTNNS] = React.useState([]);
  const [sportsCRCKT, setSportsCRCKT] = React.useState([]);
  const [sportsSoccer, setSportsSoccer] = React.useState([]);
  const [loader, setloader] = React.useState(false);
  // const [onlyList, setOnlyList] = React.useState(props.onlyList);
  const [liveOnly, setliveOnly] = React.useState(props.onlyList);
  const history = useHistory();

  const handleEgames=(props)=>{
    // console.log("Handling egames");
    const userToken = JSON.parse(localStorage.getItem("@access:token"));
    // console.log("token"+userToken);
    if (!userToken) {
      notify("Please Login first", "error", "top-right");
      history.push("/")
    }
    else{
      history.push("/eGames")
    }
  }  

  useEffect(() => {
    if (props.cricketMatches && props.cricketMatches.data) {
      let data = props.cricketMatches;
      const gameDateWise = {};
      let cricketgames = [];
      data.data.forEach((gt) => {
        const matchDate = gt.MatchDateTime.split("T")[0];
        if (!gameDateWise[matchDate]) gameDateWise[matchDate] = [];
        gameDateWise[matchDate].push(gt);
        let rateD = data.rates.filter(
          (rate) => rate.GameId === gt._id && rate.RateType === "Match Odds"
        );
        if (rateD.length === 2) {
          const tempRate = rateD.pop();
          rateD = rateD.concat([{ Name: "", Back: "-", Lay: "-" }, tempRate]);
        }
        if (rateD) gt.rates = rateD;
        cricketgames.push(gt);
      });
      cricketgames && setSportsCRCKT(cricketgames);
      cricketgames &&
        CurrentGameType == "CRCKT" &&
        setDefaultSelectedSport(cricketgames);
      setloader(false);
    }
  }, [props.cricketMatches]);
  useEffect(() => {
    if (props.soccerMatches && props.soccerMatches.data) {
      let data = props.soccerMatches;
      const gameDateWise = {};
      let soccergames = [];
      data.data.forEach((gt) => {
        const matchDate = gt.MatchDateTime.split("T")[0];
        if (!gameDateWise[matchDate]) gameDateWise[matchDate] = [];
        gameDateWise[matchDate].push(gt);
        let rateD = data.rates.filter(
          (rate) => rate.GameId === gt._id && rate.RateType === "Match Odds"
        );

        if (rateD.length === 2) {
          const tempRate = rateD.pop();
          rateD = rateD.concat([{ Name: "", Back: "-", Lay: "-" }, tempRate]);
        }
        if (rateD) gt.rates = rateD;
        soccergames.push(gt);
      });
      soccergames && setSportsSoccer(soccergames);
      soccergames &&
        CurrentGameType == "Soccer" &&
        setDefaultSelectedSport(soccergames);
      setloader(false);
    }
  }, [props.soccerMatches]);
  useEffect(() => {
    if (props.tennisMatches && props.tennisMatches.data) {
      let data = props.tennisMatches;
      const gameDateWise = {};
      let tennisgames = [];
      data.data.forEach((gt) => {
        const matchDate = gt.MatchDateTime.split("T")[0];
        if (!gameDateWise[matchDate]) gameDateWise[matchDate] = [];
        gameDateWise[matchDate].push(gt);
        let rateD = data.rates.filter(
          (rate) => rate.GameId === gt._id && rate.RateType === "Match Odds"
        );

        if (rateD.length === 2) {
          const tempRate = rateD.pop();
          rateD = rateD.concat([{ Name: "", Back: "-", Lay: "-" }, tempRate]);
        }
        if (rateD) gt.rates = rateD;

        tennisgames.push(gt);
      });
      tennisgames && setSportsTNNS(tennisgames);
      tennisgames &&
        CurrentGameType == "TNNS" &&
        setDefaultSelectedSport(tennisgames);
      setloader(false);
    }
  }, [props.tennisMatches]);
  const setDefaultSelectedSport = (games) => {
    // console.log("I m calling afterherererer", games);
    games && setSports(games);
  };
  const changeGame = (game) => {
    setgTypes(game);
    if (game && game == "Soccer") {
      sportsSoccer && setDefaultSelectedSport(sportsSoccer);
    } else if (game && game == "TNNS") {
      sportsTNNS && setDefaultSelectedSport(sportsTNNS);
    } else {
      sportsCRCKT && setDefaultSelectedSport(sportsCRCKT);
    }
  };

  //#region user not login
  const notLoginMessage = () => {
    notify("First login then place Bet", "error", "top-right");
  };
  //#endregion user not login

  const gameName = (
    id,
    eventId,
    name,
    Live,
    matchDateTime,
    inplayIcon,
    eventName,
    mob = false,
    sevent = null
  ) => {
    let matchDate = "";
    var given = moment.utc(matchDateTime).local().format("YYYY-MM-DD");
    given = moment(given);
    var current = moment().format("YYYY-MM-DD");
    current = moment(current);

    const diff1 = moment.duration(given.diff(current)).asHours();

    let matchtime = moment(matchDateTime).format("hh:mm A");

    if (diff1 === 0) {
      matchDate = "Today";
    } else if (diff1 > 0 && diff1 <= 24) {
      matchDate = "Tomorrow";
    } else {
      matchDate = moment(matchDateTime).format("ddd");
    }
    let gamename = name;
    var teams = [];
    if (gamename && gamename.indexOf(" v ") > -1) {
      teams = gamename.split(" v ");
    }
    const matcheventname =
      eventName && eventName.length > 26
        ? eventName.substring(0, 26)
        : eventName;

    return (
      <>
        {Live === true ? (
          <span className="handlemob-live">
            <span className={`animated-l-text check-inplay  ${inplayIcon ? "dot" : ""}`}>
              {" "}
              {inplayIcon ? (
                <>
                  <span>L</span>
                  <span>i</span>
                  <span>v</span>
                  <span>e</span>
                </>
              ) : (
                <>
                  <span>L</span>
                  <span>i</span>
                  <span>v</span>
                  <span>e</span>
                </>
              )}
            </span>
          </span>
        ) : (
          <span className="handlemob-live">
            <span className="check-span">
              <span>{matchDate}</span>
              <span>{matchtime}</span>
            </span>
          </span>
        )}
        <span
          className={`handle-name-mob g-name mob-name ${
            Live === true ? "" : "cc-span"
          }`}
        >
          {mob == true ? (
            <>
              {teams && teams.length > 0 ? (
                <span className="teams-item">
                  <span className="team-item" title={teams[0]}>
                    {teams[0].length > 12
                      ? teams[0].substring(0, 12) + ".."
                      : teams[0]}
                  </span>
                  <img className="vs-img" src={`${MEDIA_URL}/web-images/vs-img.png`} />
                  <span className="team-item" title={teams[1]}>
                    {teams[1].length > 12
                      ? teams[1].substring(0, 12) + ".."
                      : teams[1]}
                  </span>
                </span>
              ) : (
                <span>
                  {name.length > 12 ? name.substring(0, 12) + ".." : name}
                </span>
              )}
              <span className="event-dot">{matcheventname}</span>
            </>
          ) : (
            <>
              {teams && teams.length > 0 ? (
                <span className="teams-item">
                  <span className="team-item" title={teams[0]}>
                    {teams[0].length > 30
                      ? teams[0].substring(0, 30) + ".."
                      : teams[0]}
                  </span>
                  <img className="vs-img" src={`${MEDIA_URL}/web-images/vs-img.png`} />
                  <span className="team-item" title={teams[1]}>
                    {teams[1].length > 30
                      ? teams[1].substring(0, 30) + ".."
                      : teams[1]}
                  </span>
                </span>
              ) : (
                <span>
                  {name.length > 30 ? name.substring(0, 30) + ".." : name}
                </span>
              )}
              <span className="event-dot">{matcheventname}</span>
            </>
          )}
        </span>
        {sevent && (
          <div className="no-item d-sm-none">
            {sevent && sevent.FancyAvailable ? (
              <div className="icon-wrapper">
                <span className="r-count">
                  <span className="m-count">F</span>
                  <img
                    className="B-icon"
                    src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                    alt="Icon"
                  />
                </span>
              </div>
            ) : (
              ""
            )}
            {sevent && sevent.BookmakerAvailable ? (
              <div className="icon-wrapper">
                <span className="r-count">
                  <span className="m-count">B</span>
                  <img
                    className="B-icon"
                    src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                    alt="Icon"
                  />
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </>
    );
    // }
  };

  const showPage = (id, eventid) => {
    if (clientInfo) {
      if (props.parentprops) {
        props.parentprops.history.push(`/detail/${id}/${eventid}`);
      } else {
        props.history.push(`/detail/${id}/${eventid}`);
      }
      props && props.showHideSideBar && props.showHideSideBar();
    } else {
      notify("First login then place Bet", "error", "top-right");
    }
  };

  return (
    <>
      {!props.noshow ? (
        gTypes && gTypes === "CRCKT" ? (
          <Helmet>
            <meta charSet="utf-8" />
            <title>Live Online Cricket Betting & Odds Site In India </title>
            <meta
              name="description"
              content="Win more money with best online cricket betting odds in India! Bet on cricket at Batman247 and win big prizes! Don't wait, start betting now!"
            />
            <link rel="canonical" href={`https://Batman247.com`} />
          </Helmet>
        ) : gTypes && gTypes === "TNNS" ? (
          <Helmet>
            <meta charSet="utf-8" />
            <title>Tennis Betting Online India: Odds & Live Betting</title>
            <meta
              name="description"
              content="Boost your earnings with premier Tennis Betting Odds in India! Wager on tennis matches at Batman247 and win significant rewards"
            />
            <link rel="canonical" href={`https://Batman247.com`} />
          </Helmet>
        ) : (
          <Helmet>
            <meta charSet="utf-8" />
            <title>Best Online Soccer Betting & Odds in India</title>
            <meta
              name="description"
              content="Make money with the best online soccer betting odds in India! Bet on soccer at Batman247 and win big prizes! Don't wait, start betting now!"
            />
            <link rel="canonical" href={`https://Batman247.com`} />
          </Helmet>
        )
      ) : (
        ""
      )}
      <div className="row m-0">
        {/* Cricket Soccer Tennis button shown in mobile and Desktop */}
        {!props.onlyList && !props.liveonly && !props.hideicon && (
          <div id="games-list" className="col-lg-12 col-sm-12 matches mb-4">
            <div
              className="game-items mr-2"
              onClick={() => changeGame("CRCKT")}
            >
              <div className="top-count">
                <div className="inplay-count">
                  {sportsCRCKT &&
                    sportsCRCKT.filter((s) => s.InPlay == true).length}
                </div>
                <div className="total-count">
                  {" "}
                  {sportsCRCKT && sportsCRCKT.length}
                </div>
              </div>
              <button
                className={`${gTypes == "CRCKT" ? "active" : ""} gamecricket`}
              >
                <img
                  src={`${MEDIA_URL}/web-images/games.png`}
                  alt=""
                  className="matches_img"
                />
                Cricket
              </button>
            </div>
            <div className="blink-container">
      <div className="game-items mr-2">
        {/* <div className="top-count">
            <div className="inplay-count">0</div>
            <div className="total-count">22</div>
        </div>  */}

        <button className="gamecricket" onClick={handleEgames}>
          <img
            src={`${MEDIA_URL}/web-images/Basketballs.png`}
            alt=""
            className="soccer_img"
          />
          Egames
        </button>
      </div>
    </div>
            <div
              className="game-items mr-2"
              onClick={() => changeGame("Soccer")}
            >
              <div className="top-count">
                <div className="inplay-count">
                  {sportsSoccer &&
                    sportsSoccer.filter((s) => s.InPlay == true).length}
                </div>
                <div className="total-count">
                  {" "}
                  {sportsSoccer && sportsSoccer.length}
                </div>
              </div>
              <button
                className={`${gTypes == "Soccer" ? "active" : ""} gamecricket`}
              >
                <img
                  src={`${MEDIA_URL}/web-images/fifa.png`}
                  alt=""
                  className="soccer_img"
                />
                Soccer
              </button>
            </div>
            <div className="game-items mr-2" onClick={() => changeGame("TNNS")}>
              <div className="top-count">
                <div className="inplay-count">
                  {sportsTNNS &&
                    sportsTNNS.filter((s) => s.InPlay == true).length}
                </div>
                <div className="total-count">
                  {" "}
                  {sportsTNNS && sportsTNNS.length}
                </div>
              </div>

              <button
                className={`${gTypes == "TNNS" ? "active" : ""} gamecricket`}
              >
                <img
                  src={`${MEDIA_URL}/web-images/Tennises.png`}
                  alt=""
                  className="soccer_img"
                />
                Tennis
              </button>
            </div>
            
          </div>
        )}

        {loader && (
          <div className="col-md-12">
            <div className="type-loader">
              <ClipLoader color="#ffb80a" />
            </div>
          </div>
        )}

        {/* Cricket Soccer Tennis listing shown in mobile and Desktop sidebar */}
        {props.onlyList && props.onlyList == true ? (
          CurrentGameType && CurrentGameType == "CRCKT" ? (
            <ul className="line-game-listing">
              {sportsCRCKT && sportsCRCKT.length ? (
                sportsCRCKT.map((s, idxs) => (
                  <>
                    <li
                      className="listing-item"
                      onClick={() => {
                        s.InPlay == false && s.isEventType == "virtual"
                          ? notify("Event Not Live", "error", "top-right")
                          : showPage(s._id, s.Meta && s.Meta.t20exchange_id);
                      }}
                    >
                      {s.Name}
                    </li>
                  </>
                ))
              ) : (
                <div className="col-md-12 mb-3">
                  <div className="no-match">
                    <h1>No matches found</h1>
                  </div>
                </div>
              )}
            </ul>
          ) : CurrentGameType && CurrentGameType == "Soccer" ? (
            <ul className="line-game-listing">
              {sportsSoccer && sportsSoccer.length ? (
                sportsSoccer.map((s, idxs) => (
                  <>
                    <li
                      className="listing-item"
                      onClick={() => {
                        s.InPlay == false && s.isEventType == "virtual"
                          ? notify("Event Not Live", "error", "top-right")
                          : showPage(s._id, s.Meta && s.Meta.t20exchange_id);
                      }}
                    >
                      {s.Name}
                    </li>
                  </>
                ))
              ) : (
                <div className="col-md-12 mb-3">
                  <div className="no-match">
                    <h1>No matches found</h1>
                  </div>
                </div>
              )}
            </ul>
          ) : (
            <ul className="line-game-listing">
              {sportsTNNS && sportsTNNS.length ? (
                sportsTNNS.map((s, idxs) => (
                  <>
                    <li
                      className="listing-item"
                      onClick={() => {
                        s.InPlay == false && s.isEventType == "virtual"
                          ? notify("Event Not Live", "error", "top-right")
                          : showPage(s._id, s.Meta && s.Meta.t20exchange_id);
                      }}
                    >
                      {s.Name}
                    </li>
                  </>
                ))
              ) : (
                <div className="col-md-12 mb-3">
                  <div className="no-match">
                    <h1>No matches found</h1>
                  </div>
                </div>
              )}
            </ul>
          )
        ) : props.liveonly && props.liveonly == true ? (
          <div className="col-md-12 p-0">
            {sportsCRCKT && Object.keys(sportsCRCKT).length > 0 && (
              <>
                <div className="inplay-themebg sport-table-header in-play-sec">
                  <MdOutlineSportsCricket /> Cricket
                </div>
                <div className="home-bg-sec">
                  <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                    <thead className="login_hide">
                      <tr></tr>
                    </thead>
                    <tbody>
                      {Object.keys(sportsCRCKT)
                        .filter((sp) => sportsCRCKT[sp].InPlay == true)
                        .map((sp, idxs) => {
                          let s = sportsCRCKT[sp];
                          return (
                            <React.Fragment key={idxs + 1}>
                              <tr
                                className="pointer login_hide"
                                key={idxs + 1}
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td className={`heading-mobView space`}>
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    null,
                                    s.EventName,
                                    false
                                  )}
                                </td>
                                <td className="bb-fancy">
                                  <div className="no-item login_hide">
                                    {s && s.FancyAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">F</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {s && s.BookmakerAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">B</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </td>
                                {s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                      <div className="favourities_img mt-3 ml-2">
                                        <img
                                          src="favourities_icon.png"
                                          alt=""
                                        />
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                              {/* mobile view list */}
                              <tr
                                className="d-sm-none vv"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td colSpan="6" className="mob-tap">
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    "inplayIcon",
                                    s.EventName,
                                    true,
                                    s
                                  )}
                                </td>
                              </tr>
                              <tr
                                className="d-sm-none cc"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                {s.rates && s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    {/* <div className="add_favourities">
                                        <img className="img_favour" src="add-to-favourites.png" />
                                      </div> */}
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                  </>
                                )}
                                {}
                              </tr>
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {sportsSoccer && Object.keys(sportsSoccer).length > 0 && (
              <>
                <div className="inplay-themebg sport-table-header in-play-sec">
                  <MdOutlineSportsSoccer /> Soccer
                </div>
                <div className="home-bg-sec">
                  <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                    <thead className="login_hide">
                      <tr></tr>
                    </thead>
                    <tbody>
                      {Object.keys(sportsSoccer)
                        .filter((sp) => sportsSoccer[sp].InPlay == true)
                        .map((sp, idxs) => {
                          let s = sportsSoccer[sp];
                          return (
                            <React.Fragment key={idxs + 1}>
                              <tr
                                className="pointer login_hide"
                                key={idxs + 1}
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td className={`heading-mobView space`}>
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    null,
                                    s.EventName,
                                    false
                                  )}
                                </td>
                                <td className="bb-fancy">
                                  <div className="no-item login_hide">
                                    {s && s.FancyAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">F</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {s && s.BookmakerAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">B</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </td>
                                {s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                      <div className="favourities_img mt-3 ml-2">
                                        <img
                                          src="favourities_icon.png"
                                          alt=""
                                        />
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                              {/* mobile view list */}
                              <tr
                                className="d-sm-none vv"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td colSpan="6" className="mob-tap">
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    "inplayIcon",
                                    s.EventName,
                                    true,
                                    s
                                  )}
                                </td>
                              </tr>
                              <tr
                                className="d-sm-none cc"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                {s.rates && s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    {/* <div className="add_favourities">
                                        <img className="img_favour" src="add-to-favourites.png" />
                                      </div> */}
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                  </>
                                )}
                                {}
                              </tr>
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {sportsTNNS && Object.keys(sportsTNNS).length > 0 && (
              <>
                <div className="inplay-themebg sport-table-header in-play-sec">
                  <MdSportsTennis /> Tennis
                </div>
                <div className="home-bg-sec">
                  <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                    <thead className="login_hide">
                      <tr></tr>
                    </thead>
                    <tbody>
                      {Object.keys(sportsTNNS)
                        .filter((sp) => sportsTNNS[sp].InPlay == true)
                        .map((sp, idxs) => {
                          let s = sportsTNNS[sp];
                          return (
                            <React.Fragment key={idxs + 1}>
                              <tr
                                className="pointer login_hide"
                                key={idxs + 1}
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td className={`heading-mobView space`}>
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    null,
                                    s.EventName,
                                    false
                                  )}
                                </td>
                                <td className="bb-fancy">
                                  <div className="no-item login_hide">
                                    {s && s.FancyAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">F</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {s && s.BookmakerAvailable ? (
                                      <div className="icon-wrapper">
                                        <span className="r-count">
                                          <span className="m-count">B</span>
                                          <img
                                            className="B-icon"
                                            src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                            alt="Icon"
                                          />
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </td>
                                {s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                      <div className="favourities_img mt-3 ml-2">
                                        <img
                                          src="favourities_icon.png"
                                          alt=""
                                        />
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                              {/* mobile view list */}
                              <tr
                                className="d-sm-none vv"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                <td colSpan="6" className="mob-tap">
                                  {gameName(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id,
                                    s.Name,
                                    s.InPlay,
                                    s.MatchDateTime,
                                    "inplayIcon",
                                    s.EventName,
                                    true,
                                    s
                                  )}
                                </td>
                              </tr>
                              <tr
                                className="d-sm-none cc"
                                onClick={() => {
                                  s.InPlay == false &&
                                  s.isEventType == "virtual"
                                    ? notify(
                                        "Event Not Live",
                                        "error",
                                        "top-right"
                                      )
                                    : showPage(
                                        s._id,
                                        s.Meta && s.Meta.t20exchange_id
                                      );
                                }}
                              >
                                {s.rates && s.rates.length > 0 ? (
                                  s.rates
                                    .filter((rate, rateIdx) => rateIdx < 3)
                                    .map((rate, rIdx) => (
                                      <React.Fragment key={rIdx + 1}>
                                        <td className="bg-back text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Back === 0 ? "-" : rate.Back}
                                          </span>
                                        </td>
                                        <td className="bg-lay text-center g-rate-name">
                                          <span className="identity">
                                            {rate.Lay === 0 ? "-" : rate.Lay}
                                          </span>
                                        </td>
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <>
                                    {/* <div className="add_favourities">
                                        <img className="img_favour" src="add-to-favourites.png" />
                                      </div> */}
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">-</span>
                                    </td>
                                  </>
                                )}
                                {}
                              </tr>
                            </React.Fragment>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="col-md-12 p-0">
            {Object.keys(sports).length ? (
              <div className="home-bg-sec srxxxx">
                <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                  <thead className="login_hide">
                    <tr></tr>
                  </thead>
                  <tbody>
                    {Object.keys(sports).map((item, idxs) => {
                      let s = sports[item];
                      return (
                        <React.Fragment key={idxs + 1}>
                          <tr
                            className="pointer login_hide"
                            key={idxs + 1}
                            onClick={() => {
                              s.InPlay == false && s.isEventType == "virtual"
                                ? notify("Event Not Live", "error", "top-right")
                                : showPage(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id
                                  );
                            }}
                          >
                            <td className={`heading-mobView space`}>
                              {gameName(
                                s._id,
                                s.Meta && s.Meta.t20exchange_id,
                                s.Name,
                                s.InPlay,
                                s.MatchDateTime,
                                null,
                                s.EventName,
                                false
                              )}
                            </td>
                            <td className="bb-fancy">
                              <div className="no-item login_hide">
                                {s && s.FancyAvailable ? (
                                  <div className="icon-wrapper">
                                    <span className="r-count">
                                      <span className="m-count">F</span>
                                      <img
                                        className="B-icon"
                                        src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                        alt="Icon"
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {s && s.BookmakerAvailable ? (
                                  <div className="icon-wrapper">
                                    <span className="r-count">
                                      <span className="m-count">B</span>
                                      <img
                                        className="B-icon"
                                        src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                        alt="Icon"
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                            {s.rates.length > 0 ? (
                              s.rates
                                .filter((rate, rateIdx) => rateIdx < 3)
                                .map((rate, rIdx) => (
                                  <React.Fragment key={rIdx + 1}>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">
                                        {rate.Back === 0 ? "-" : rate.Back}
                                      </span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">
                                        {rate.Lay === 0 ? "-" : rate.Lay}
                                      </span>
                                    </td>
                                  </React.Fragment>
                                ))
                            ) : (
                              <>
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                  <div className="favourities_img mt-3 ml-2">
                                    <img src="favourities_icon.png" alt="" />
                                  </div>
                                </td>
                              </>
                            )}
                          </tr>
                          {/* mobile view list */}
                          <tr
                            className="d-sm-none vv"
                            onClick={() => {
                              s.InPlay == false && s.isEventType == "virtual"
                                ? notify("Event Not Live", "error", "top-right")
                                : showPage(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id
                                  );
                            }}
                          >
                            <td colSpan="6" className="mob-tap">
                              {gameName(
                                s._id,
                                s.Meta && s.Meta.t20exchange_id,
                                s.Name,
                                s.InPlay,
                                s.MatchDateTime,
                                "inplayIcon",
                                s.EventName,
                                true,
                                s
                              )}
                            </td>
                          </tr>
                          <tr
                            className="d-sm-none cc"
                            onClick={() => {
                              s.InPlay == false && s.isEventType == "virtual"
                                ? notify("Event Not Live", "error", "top-right")
                                : showPage(
                                    s._id,
                                    s.Meta && s.Meta.t20exchange_id
                                  );
                            }}
                          >
                            {s.rates && s.rates.length > 0 ? (
                              s.rates
                                .filter((rate, rateIdx) => rateIdx < 3)
                                .map((rate, rIdx) => (
                                  <React.Fragment key={rIdx + 1}>
                                    <td className="bg-back text-center g-rate-name">
                                      <span className="identity">
                                        {rate.Back === 0 ? "-" : rate.Back}
                                      </span>
                                    </td>
                                    <td className="bg-lay text-center g-rate-name">
                                      <span className="identity">
                                        {rate.Lay === 0 ? "-" : rate.Lay}
                                      </span>
                                    </td>
                                  </React.Fragment>
                                ))
                            ) : (
                              <>
                                {/* <div className="add_favourities">
                                        <img className="img_favour" src="add-to-favourites.png" />
                                      </div> */}
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-back text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                                <td className="bg-lay text-center g-rate-name">
                                  <span className="identity">-</span>
                                </td>
                              </>
                            )}
                            {}
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <div className="col-md-12 mb-3">
                <div className="no-match">
                  <h1>No matches found</h1>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Cricket Soccer Tennis table shown in mobile and Desktop */}
        {loader ? (
          <div className="col-md-12">
            <div className="type-loader">
              <ClipLoader color="#ffb80a" />
            </div>
          </div>
        ) : sports && !props.onlyList && Object.keys(sports).length > 0 ? (
          Object.keys(sports)
            .sort()
            .map((sp, idx) =>
              sp.length > 0 && props.liveOnly && props.liveOnly == true ? (
                <div className="col-md-12 p-0" key={idx + 1}>
                  <div className="inplay-themebg sport-table-header in-play-sec">
                    <p className="">
                      {sp && sp === "CRCKT" ? (
                        <span>
                          <MdOutlineSportsCricket /> Cricket
                        </span>
                      ) : sp && sp === "TNNS" ? (
                        <span>
                          {" "}
                          <MdSportsTennis /> Tennis
                        </span>
                      ) : (
                        <span>
                          <MdOutlineSportsSoccer /> Soccer
                        </span>
                      )}
                    </p>
                  </div>
                  <div className="home-bg-sec">
                    <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                      <thead className="login_hide">
                        <tr></tr>
                      </thead>
                      <tbody>
                        {sports[sp].length
                          ? sports[sp].map((s, idxs) => (
                              <React.Fragment key={idxs + 1}>
                                <tr
                                  className="pointer login_hide"
                                  key={idxs + 1}
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  <td className={`heading-mobView space`}>
                                    {gameName(
                                      s._id,
                                      s.Meta && s.Meta.t20exchange_id,
                                      s.Name,
                                      s.InPlay,
                                      s.MatchDateTime,
                                      null,
                                      s.EventName,
                                      false
                                    )}
                                  </td>
                                  <td className="bb-fancy">
                                    <div className="no-item login_hide">
                                      {s && s.FancyAvailable ? (
                                        <div className="icon-wrapper">
                                          <span className="r-count">
                                            <span className="m-count">F</span>
                                            <img
                                              className="B-icon"
                                              src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                              alt="Icon"
                                            />
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {s && s.BookmakerAvailable ? (
                                        <div className="icon-wrapper">
                                          <span className="r-count">
                                            <span className="m-count">B</span>
                                            <img
                                              className="B-icon"
                                              src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                              alt="Icon"
                                            />
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>
                                  {s.rates.length > 0 ? (
                                    s.rates
                                      .filter((rate, rateIdx) => rateIdx < 3)
                                      .map((rate, rIdx) => (
                                        <React.Fragment key={rIdx + 1}>
                                          <td className="bg-back text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Back === 0
                                                ? "-"
                                                : rate.Back}
                                            </span>
                                          </td>
                                          <td className="bg-lay text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Lay === 0 ? "-" : rate.Lay}
                                            </span>
                                          </td>
                                        </React.Fragment>
                                      ))
                                  ) : (
                                    <>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                        <div className="favourities_img mt-3 ml-2">
                                          <img
                                            src="favourities_icon.png"
                                            alt=""
                                          />
                                        </div>
                                      </td>
                                    </>
                                  )}
                                </tr>
                                {/* mobile view list */}
                                <tr
                                  className="d-sm-none vv"
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  <td colSpan="6" className="mob-tap">
                                    {gameName(
                                      s._id,
                                      s.Meta && s.Meta.t20exchange_id,
                                      s.Name,
                                      s.InPlay,
                                      s.MatchDateTime,
                                      "inplayIcon",
                                      s.EventName,
                                      true,
                                      s
                                    )}
                                  </td>
                                </tr>
                                <tr
                                  className="d-sm-none cc"
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  {s.rates && s.rates.length > 0 ? (
                                    s.rates
                                      .filter((rate, rateIdx) => rateIdx < 3)
                                      .map((rate, rIdx) => (
                                        <React.Fragment key={rIdx + 1}>
                                          <td className="bg-back text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Back === 0
                                                ? "-"
                                                : rate.Back}
                                            </span>
                                          </td>
                                          <td className="bg-lay text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Lay === 0 ? "-" : rate.Lay}
                                            </span>
                                          </td>
                                        </React.Fragment>
                                      ))
                                  ) : (
                                    <>
                                      {/* <div className="add_favourities">
                                        <img className="img_favour" src="add-to-favourites.png" />
                                      </div> */}
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                    </>
                                  )}
                                  {}
                                </tr>
                              </React.Fragment>
                            ))
                          : null}
                      </tbody>
                    </Table>
                  </div>
                </div>
              ) : (
                ""
              )
            )
        ) : (
          ""
        )}

        {!props.onlyList ? (
          loader ? (
            <div className="col-md-12">
              <div className="type-loader">
                <ClipLoader color="#ffb80a" />
              </div>
            </div>
          ) : Object.keys(sports).length > 0 ? (
            <div
              className={`col-md-12 mob-no-pad ${
                !props.noshow ? "mt-3" : "p-0"
              }`}
            >
              <div className="home-bg-sec">
                <Table className="ad-change home bet-table t-width responsive hover table p-bg-5 mb-0">
                  <thead className="">{/* table head will go here */}</thead>
                  <tbody>
                    {Object.keys(sports)
                      .sort()
                      .map((sp, idx) =>
                        sports[sp].length
                          ? sports[sp].map((s, idxs) => (
                              <React.Fragment key={idxs + 1}>
                                <tr
                                  className="pointer login_hide"
                                  key={idxs + 1}
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  <td className={`heading-mobView space`}>
                                    {gameName(
                                      s._id,
                                      s.Meta && s.Meta.t20exchange_id,
                                      s.Name,
                                      s.InPlay,
                                      s.MatchDateTime,
                                      null,
                                      s.EventName,
                                      false
                                    )}
                                  </td>
                                  <td className="bb-fancy">
                                    <div className="no-item login_hide">
                                      {s && s.FancyAvailable ? (
                                        <div className="icon-wrapper">
                                          <span className="r-count">
                                            <span className="m-count">F</span>
                                            <img
                                              className="B-icon"
                                              src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                              alt="Icon"
                                            />
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {s && s.BookmakerAvailable ? (
                                        <div className="icon-wrapper">
                                          <span className="r-count">
                                            <span className="m-count">B</span>
                                            <img
                                              className="B-icon"
                                              src={`${MEDIA_URL}/web-images/yellow-bg-icon.png`}
                                              alt="Icon"
                                            />
                                          </span>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                   
                                  </td>
                                  {s.rates.length > 0 ? (
                                    s.rates
                                      .filter((rate, rateIdx) => rateIdx < 3)
                                      .map((rate, rIdx) => (
                                        <React.Fragment key={rIdx + 1}>
                                          <td className="bg-back text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Back === 0
                                                ? "-"
                                                : rate.Back}
                                            </span>
                                          </td>
                                          <td className="bg-lay text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Lay === 0 ? "-" : rate.Lay}
                                            </span>
                                          </td>
                                        </React.Fragment>
                                      ))
                                  ) : (
                                    <>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                        <div className="favourities_img mt-3 ml-2">
                                          <img
                                            src="favourities_icon.png"
                                            alt=""
                                          />
                                        </div>
                                      </td>
                                    </>
                                  )}
                                </tr>
                                {/* mobile view list */}
                                <tr
                                  className="d-sm-none vv"
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  <td colSpan="6" className="mob-tap">
                                    {gameName(
                                      s._id,
                                      s.Meta && s.Meta.t20exchange_id,
                                      s.Name,
                                      s.InPlay,
                                      s.MatchDateTime,
                                      "inplayIcon",
                                      s.EventName,
                                      true,
                                      s
                                    )}
                                  </td>
                                </tr>
                                <tr
                                  className="d-sm-none cc"
                                  onClick={() => {
                                    s.InPlay == false &&
                                    s.isEventType == "virtual"
                                      ? notify(
                                          "Event Not Live",
                                          "error",
                                          "top-right"
                                        )
                                      : showPage(
                                          s._id,
                                          s.Meta && s.Meta.t20exchange_id
                                        );
                                  }}
                                >
                                  {s.rates && s.rates.length > 0 ? (
                                    s.rates
                                      .filter((rate, rateIdx) => rateIdx < 3)
                                      .map((rate, rIdx) => (
                                        <React.Fragment key={rIdx + 1}>
                                          <td className="bg-back text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Back === 0
                                                ? "-"
                                                : rate.Back}
                                            </span>
                                          </td>
                                          <td className="bg-lay text-center g-rate-name">
                                            <span className="identity">
                                              {rate.Lay === 0 ? "-" : rate.Lay}
                                            </span>
                                          </td>
                                        </React.Fragment>
                                      ))
                                  ) : (
                                    <>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-back text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                      <td className="bg-lay text-center g-rate-name">
                                        <span className="identity">-</span>
                                      </td>
                                    </>
                                  )}

                                  {}
                                </tr>
                              </React.Fragment>
                            ))
                          : null
                      )}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default GamesListing;
